import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './organisation-files.styles'
import OrganisationFilesTable from './organisation-files-table/organisation-files-table.container'
import CurrentSkeleton from './organisation-files-skeleton/current-skeleton'
import octopus from './octopus.png'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import FormLabel from 'pobble-components/dist/form-elements/form-label'

class OrganisationFiles extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const {
      classes,
      pending,
      noOrganisationFiles,
      benchmarkFilter
    } = this.props
    let filters = (
      <div className={classes.filter}>
        <FormLabel className={classes.label}>Filter:</FormLabel>
        <FormSelect
          value={benchmarkFilter ? 'benchmarked' : 'all'}
          onChange={e => this.props.onSelect(e.target.value, benchmarkFilter)}>
          <option value="all">All</option>
          <option value="benchmarked">Exemplars</option>
        </FormSelect>
      </div>
    )
    return noOrganisationFiles ? (
      <div>
        {filters}
        <img src={octopus} className={classes.illustration} alt="Not Found" />
        <p className={classes.container}>There are no moderation files yet.</p>
      </div>
    ) : pending ? (
      <CurrentSkeleton />
    ) : (
      <>
        {filters}
        <OrganisationFilesTable />
      </>
    )
  }
}

export default injectSheet(styles)(OrganisationFiles)
